import React, {Component} from 'react';
import { unmountComponentAtNode } from "react-dom";
import { Redirect } from 'react-router-dom';
import {base, appDatabasePrimaryFunctions} from '../../base';
import { confirmAlert } from '../../components/utils/react-confirm-alert.js';
import Confetti from 'react-confetti';
// import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../styles/css/react-confirm-alert.css';
import '../../styles/css/Home.css';
import '../../styles/css/ConfirmAlertCustom.css';
import '../../styles/css/main.css';
import '../../styles/css/CreatorAwards.css';


class Main_App extends Component {

    constructor(props) {
        super(props);
        this.state = {
          userEmail: localStorage.getItem('userEmail') || false,
          alerted: false,
          // answerList: [],
          gameActive: false,
          fullName: '',
          phone: '',
          zip: '',
          tenantRules: {},
          question: 0,
          questions: [],
          questionAnswered: false,
          formFilledOut: false,
          userAnswers: [],
          alreadyUpdate: "",
          currentGameId: null,
          currentTiviaGameTime: false,
          currentResponseArray: [],
          startConfetti: false,
          rotationStarted: false,
          optedIntoEmail: {},
          tierMessaging: []
        };
        this.logout = this.logout.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    removeReactAlert(){
      document.body.classList.remove('react-confirm-alert-body-element')
      const target = document.getElementById('react-confirm-alert')
      if(target){
        unmountComponentAtNode(target)
        target.parentNode.removeChild(target)
      }
      const svg = document.getElementById('react-confirm-alert-firm-svg')
      if(svg){
        svg.parentNode.removeChild(svg)
        document.body.children[0].classList.remove('react-confirm-alert-blur')
      }
    }

    componentDidMount() {
      if(!navigator.cookieEnabled){
        alert("You do not have cookies enabled! Please change the settings of your browser");
        return;
      }

      this.currentTriviaGameKeyRef = base.listenTo(`currentTriviaGame/id`, {
        context: this,
        then(key){
          this.logUserActivity(key);
          this.removeReactAlert();
          this.setState({
            currentGameId:key,
            startConfetti: false
          }, ()=> {
            this.currentGameFormFilledRef = base.listenTo('currentGameFormFilled/'+ this.state.currentGameId +'/' +base64EncodedEmail, {
              context: this,
              state: 'formFilledOut',
              then(response){
                if(response.name){
                  document.getElementById('more-info-form').style.display = "none"
                  document.getElementById('thanks-for-playing-section').style.display = ""
                }
              }
            })
          })
        }
      });

      this.tenantRulesRef = base.bindToState(`tenantRules`, {
        context: this,
        state: 'tenantRules',
      });
      var userEmail = this.state.userEmail;
      var base64EncodedEmail = btoa(userEmail);

      this.gameActiveRef = base.bindToState('currentTriviaGame/active', {
        context: this,
        state: 'gameActive',
      })

      // this.questionAnsweredRef = base.bindToState('currentTriviaGame/answered', {
      //   context: this,
      //   state: 'questionAnswered',
      // })

      this.gameStartTime = base.bindToState('currentTriviaGame/timeStamp', {
        context: this,
        state: 'currentTiviaGameTime',
      })

      this.rotationStartedRef = base.bindToState('currentTriviaGame/rotate', {
        context: this,
        state: 'rotationStarted',
      })

      this.tierMessagingRef = base.bindToState('tierMessaging', {
        context: this,
        state: 'tierMessaging',
      })

      this.questionRef = base.bindToState('currentTriviaGame/questions', {
        context: this,
        state: 'questions',
        asArray: true
      })

      this.currentResponseArrayRef = base.listenTo('userAnswers/'+base64EncodedEmail, {
        context: this,
        state: 'currentResponseArray',
        asArray: true,
        then(arrayOfAnswers){
          var numberOfAnswers = arrayOfAnswers.length;
          if(numberOfAnswers > 0){
            numberOfAnswers = numberOfAnswers - 1
          }
          if(numberOfAnswers === this.state.questions.length){
            this.setState({
              questionAnswered: true,
              question:numberOfAnswers,
              currentResponseArray: arrayOfAnswers
            })
          } else {
            this.setState({
              questionAnswered: false,
              question: numberOfAnswers,
              currentResponseArray: arrayOfAnswers
            })
          }
        }
      })

      this.prizesWonRef = base.listenTo('prizeWon/'+base64EncodedEmail, {
        context: this,
        then(winnerPrize){
          if(winnerPrize === true){
            this.showGameOverMessage(true)
          } else if(winnerPrize === false) {
            this.showGameOverMessage(false)
          }
        }
      })
    }

    handleChange(event) {
      this.setState({[event.target.name]: event.target.value});
    }

    componentWillUnmount() {
      base.removeBinding(this.rotationStartedRef);
      base.removeBinding(this.currentTriviaGameKeyRef);
      base.removeBinding(this.tierMessagingRef);
      base.removeBinding(this.currentResponseArrayRef);
      base.removeBinding(this.tenantRulesRef);
      base.removeBinding(this.questionRef);
      if(this.currentGameFormFilledRef){
        base.removeBinding(this.currentGameFormFilledRef);
      }
      base.removeBinding(this.gameActiveRef);
    }

    logout(){
      localStorage.removeItem('userEmail');
      this.setState({
        userEmail:false
      })
    }

    showGameOverMessage(gotWinningMessage){
      var currentAnswerArray = this.state.currentResponseArray;
      var questions = this.state.questions;
      var answers = [];
      for(var y in questions){
        var questionAnswers = questions[y].answers;
        for(var answer in questionAnswers){
          if(currentAnswerArray.indexOf(questionAnswers[answer].id) != -1){
            questionAnswers[answer].shown =  questions[y].shown;
            answers.push(questionAnswers[answer])
          }
        }
      }
      var count = 0;
      for(var answerIndex in answers){
        var answer = answers[answerIndex];
        if(answer.correct){
          count+=1
        }
      }
      var tierMessages = this.state.tierMessaging[count]
      var headerHeader = null
      var headerMessage = null
      if(gotWinningMessage){
        headerHeader = tierMessages.winningHeader;
        headerMessage = tierMessages.winningMessage;
        this.setState({
          startConfetti: true
        })
      } else if (count > 0 && gotWinningMessage === false) {
        headerHeader = tierMessages.winningMissedHeader;
        headerMessage = tierMessages.winningMissedMessage;
        this.setState({
          startConfetti: true
        })
      } else {
        headerHeader = tierMessages.losingHeader;
        headerMessage = tierMessages.losingMessage;
      }
      confirmAlert({
        variables: this.props.variables,
        title: headerHeader,
        message: headerMessage,
        buttons: [
          {
            label: 'OK',
            onClick: () => this.setState({startConfetti:false})
          }
        ]
      })
    }

    logUserActivity(currentGame){
      var vm = this;
      if(currentGame){
        var gameid = currentGame;
        var userEmailToBase64 = btoa(this.state.userEmail);
        base.post('userGameHistory/'+userEmailToBase64+`/${gameid}` , {
          data:gameid,
          then(err){
            if(!err){
              vm.setState({
                alreadyUpdate: gameid,
              })
              console.log("user game logged!")
            }
          }
        })
      }
    }

    onClickAnswer(answerClicked, position){
      var gridItem = document.getElementById(answerClicked.id);
      gridItem.style.backgroundColor = localStorage.getItem('primaryColor');
      if(this.state.rotationStarted){
        confirmAlert({
          variables: this.props.variables,
          title: 'Answers showing on scoreboard',
          message: "Can't pick an answer once the scoreboard has started showing them",
          buttons: [
            {
              label: 'OK',
              onClick: () => gridItem.style.backgroundColor = "transparent"
            }
          ]
        })
        return
      }
      var answerInfo = {};
      // document.getElementsByClassName("grid")
      // document.getElement react-confirm-alert-button-group button
      answerInfo['answerText'] = answerClicked.answerText;
      answerInfo['position'] = position;
      answerInfo['questionId'] = "questionID"
      answerInfo['answerId'] = answerClicked.id;
      answerInfo['timeAnswered'] = Date.now();
      answerInfo['email'] = this.state.userEmail;

      // if(this.state.userEmail.trim() === ""){
      //   alert("This email is strange, please logout and try a different one!")
      //   return;
      // }
      // if(this.state.currentResponse.answerId){
      //   confirmAlert({
      //     title: 'Answer already picked!',
      //     message: "You already have an answer selected so you can't pick another one",
      //     buttons: [
      //       {
      //         label: 'OK',
      //       }
      //     ]
      //   })
      //   return;
      // }
      // this.setState({
      //   currentResponse: answerInfo
      // })
      var base64EncodedEmail = btoa(this.state.userEmail);

      // var vm = this;
      var questionId = this.state.questions[this.state.question].id;
      var postToUserAnswers = {}
      postToUserAnswers["/userAnswers/" + base64EncodedEmail + "/" + questionId] = answerClicked.id;
      postToUserAnswers["/userAnswers/" + base64EncodedEmail + '/timeStamp'] = new Date().getTime().toString();
      // base.post(`userAnswers/${base64EncodedEmail}/${questionId}`, {
      appDatabasePrimaryFunctions.ref().update(postToUserAnswers, function(error){
        if(!error){
          console.log("Answer Clicked");
          gridItem.style.backgroundColor = "transparent";
        } else {
          console.log(error)
          confirmAlert({
              variables: this.props.variables,
              title: 'There was an error',
              message: error.message,
              buttons: [
                {
                  label: 'OK',
                }
              ]
            })
        }
      })
    }

    renderHoldingScreen(){
      var tenantVariables = this.props.variables || {};
      return(
        <div className="flex-content-container-home">
          <div className="flex-header-home">
            <div className="header-left">
              <img className="topLeftLogo" alt=""/>
            </div>
            <div className="header-right">
              <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: '#fff', borderColor: '#fff'}}>LOG OUT</button>
            </div>
          </div>
          <div className="intro-container-home" >
            <div className="hero-text-container">
              <img src={tenantVariables.frontLogoImage} className="main-hero-image" alt=""/>
            </div>
            <p style={{display: tenantVariables.playingText ? '' : "none", color:tenantVariables.secondaryColor}}>Next game starts during <br/><span className="emphasizedText" style={{backgroundColor:tenantVariables.primaryColor, color:tenantVariables.secondaryColor}}>{tenantVariables.playingText}</span></p>
          </div>
        </div>
        )
    }

    renderPlayingScreen(){
      var tenantVariables = this.props.variables || {};
      var questions = this.state.questions;
      var answerList = [];
      // var currentAnswerArray = this.state.currentResponseArray;
      var question = {};
      if(this.state.questions.length > 0){
        var questionNumber = this.state.question;
        question = this.state.questions[questionNumber];
        answerList = this.state.questions[questionNumber].answers;
      }
      return(
        <div className="flex-content-container-home">
          <div className="intro-container-home">
            <div className="grid-wrapper">
              <div className="creator-awards-logo-playscreen user"><img src={tenantVariables.topLeftImage} alt="" style={{marginBottom:"0"}}/></div>
              <div className="card" style={{borderRadius:"20px", marginTop:'0',paddingTop:'0'}}>
                <div className="top-text">
                    <p className="top-text-mobile" style={{wordWrap: "break-word", fontWeight:700, color:tenantVariables.secondaryColor}}>{question.questionText}</p>
                </div>
                <div className="grid-container user" style={{gridAutoFlow:"row", transform:"translateY(0%)"}}>
                  {
                    answerList.map(function(item,i){
                        return <div
                                  key={i}
                                  id={item.id}
                                  className="grid-item"
                                  onClick={()=>this.onClickAnswer(item, i)}
                                  style={{background: 'transparent', color:tenantVariables.secondaryColor, boxShadow:"unset", borderColor:tenantVariables.secondaryColor, display:"inline-flex", alignItems: "center", maxWidth:"380px", minWidth:"100px"}}>
                                  <span style={{marginLeft:"auto", marginRight:"auto"}}>{item.answerText}</span>
                                </div>
                    }, this)
                  }
                  <div style={{width:"100%", textAlign: "center"}}>
                    <img width="100%" src={tenantVariables.sponsorLogo} alt="" style={{maxWidth:"380px"}}/>
                  </div>
                </div>
                <div className="mobilehide" style={{height:"100px", width:"1px"}}></div>
              </div>
            </div>
          </div>
        </div>
        )
    }

    handleSubmit(event){
      event.preventDefault();
      var zip = this.state.zip.trim();
      var name = this.state.fullName.trim();
      var phone = this.state.phone.trim();
      var timesubmitted = Date.now();
      var receive_emails = this.refs.want_emails.checked;
      if(!this.refs.agree_to_rules_regs.checked){
        confirmAlert({
          variables: this.props.variables,
          title: 'Missing Info',
          message: "Please agree to rules and regulations!",
          buttons: [
            {
              label: 'OK',
            }
          ]
        })
        return;
        }
      if(zip.length === 0 || name.length === 0 || phone === 0){
        confirmAlert({
          variables: this.props.variables,
          title: 'Missing Info',
          message: "Please fill out all information before submitting this form",
          buttons: [
            {
              label: 'OK',
            }
          ]
        })
        return;
      }
      var base64EncodedEmail = btoa(this.state.userEmail);
      // var vm = this;
      var formData = {name: name, phone: phone, zip: zip, receive_emails: receive_emails, timeSubmitted: timesubmitted}
      base.post(`currentGameFormFilled/`+ this.state.currentGameId +'/' +base64EncodedEmail, {
        data: formData,
        then(err){
          if(!err){
            document.getElementById('more-info-form').style.display = "none"
            document.getElementById('thanks-for-playing-section').style.display = ""
          } else {
            console.log(err)
            confirmAlert({
                variables: this.props.variables,
                title: 'There was an error',
                message: err.message,
                buttons: [
                  {
                    label: 'OK',
                  }
                ]
              })
          }
        }
      });
    }

    thanksForPlayingScreen(){
      var tenantVariables = this.props.variables || {};
      var currentAnswerArray = this.state.currentResponseArray;
      var currentTriviaGameTime = this.state.currentTiviaGameTime;
      var nowInMilli = Date.now();
      var hoursInMillisecnods24 = 86400000;
      var hideAnswerForm = false
      if(currentTriviaGameTime && (currentTriviaGameTime + hoursInMillisecnods24) < nowInMilli){
        hideAnswerForm = true
      }
      var questions = this.state.questions;
      var answers = [];
      for(var y in questions){
        var questionAnswers = questions[y].answers;
        for(var answer in questionAnswers){
          if(currentAnswerArray.indexOf(questionAnswers[answer].id) != -1){
            questionAnswers[answer].shown =  questions[y].shown;
            answers.push(questionAnswers[answer])
          }
        }
      }

      return(
        <div className="flex-content-container-home">
          <div className="flex-header-home">
            <Confetti style={{display: this.state.startConfetti ? '' : 'none', zIndex: 1}}/>
            <div className="header-left">
              <img className="topLeftLogo" alt=""/>
            </div>
            <div className="header-right">
              <button className="btn btn-logout" onClick={() => { this.logout() }} style={{color: '#fff', borderColor: '#fff'}}>LOG OUT</button>
            </div>
          </div>
          <center className="creator-awards-logo-playscreen user"><img src={tenantVariables.topAnswerImage} alt="" style={{marginBottom:"0"}}/></center>
          <div className="intro-container-home" style={{marginTop:'20px'}}>
            <p className="top-text-mobile" style={{color:tenantVariables.secondaryColor, marginBottom: 0}}>Answers are coming up on the scoreboard</p>
            <div className="top-text">
                <p className="top-text-mobile"><span className="emphasizedTextAnswers" style={{backgroundColor:tenantVariables.primaryColor, color:tenantVariables.secondaryColor}}>My Answers</span></p>
            </div>
            {/*<div className="hero-text-container">
              <img src={tenantVariables.frontLogoImage} className="main-hero-image" alt=""/>
              <p>Your Answers</p>
            </div>*/}

            <center className="grid-container user" style={{gridAutoFlow:"row", transform:"translateY(0%)"}}>
              {
                answers.map(function(item,i){
                  if(item.shown && item.correct){
                    return <div
                            key={i}
                            className="endAnswers grid-item"
                            style={{background: 'transparent', backgroundColor:tenantVariables.correctTextColor, color:tenantVariables.secondaryColor, boxShadow:"unset", borderColor:tenantVariables.secondaryColor, display:"inline-flex", alignItems: "center", maxWidth:"380px", minWidth:"100px"}}>
                            <span style={{marginLeft:"auto", marginRight:"auto"}}>{item.answerText}</span>
                          </div>
                  } else if (item.shown && !item.correct) {
                    return <div
                            key={i}
                            className="endAnswers grid-item"
                            style={{background: 'transparent', backgroundColor:tenantVariables.incorrectTextColor, color:tenantVariables.secondaryColor, boxShadow:"unset", borderColor:tenantVariables.secondaryColor, display:"inline-flex", alignItems: "center", maxWidth:"380px", minWidth:"100px"}}>
                            <span style={{marginLeft:"auto", marginRight:"auto"}}>{item.answerText}</span>
                          </div>
                  } else {
                    return <div
                            key={i}
                            className="endAnswers grid-item"
                            style={{background: 'transparent', color:tenantVariables.secondaryColor, boxShadow:"unset", borderColor:tenantVariables.secondaryColor, display:"inline-flex", alignItems: "center", maxWidth:"380px", minWidth:"100px"}}>
                            <span style={{marginLeft:"auto", marginRight:"auto"}}>{item.answerText}</span>
                          </div>
                  }
                }, this)
              }
              <div className="container-out" id="more-info-form" style={{display: tenantVariables.formHeaderText === "" || hideAnswerForm || !tenantVariables.formHeaderText ? 'none': 'block'}}>
                <div className="question-box question-form" style={{padding:'15px'}}>
                  <h4 style={{fontFamily: "Oswald", fontWeight: 700}}>{tenantVariables.formHeaderText}</h4>
                  <form onSubmit={this.handleSubmit} id="user-values-form">
                    <div className="input-group">
                      <input id="fullName" name="fullName" type="text" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Full Name" />
                    </div>
                    <div className="input-group">
                      <input id="phone" name="phone" type="tel" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Phone" />
                    </div>
                    <div className="input-group">
                      <input id="zip" name="zip" type="text" pattern="[0-9]*" style={{fontFamily: "Oswald"}} className="form-control" onChange={this.handleChange} placeholder="Zip" />
                    </div>
                    <div className="checkbox" style={{padding:'5px'}}>
                      <label className="agree_to_rules_class"><input type="checkbox" ref="agree_to_rules_regs"/> I Agree To <a target="_blank" href={this.state.tenantRules.rulesAndRegsLink}>Rules And Regulations</a></label>
                    </div>
                    <div className="checkbox" style={{padding:'5px'}}>
                      <label className="want_emails"><input type="checkbox" ref="want_emails" defaultChecked/> I want to receive emails </label>
                    </div>
                    <button style={{backgroundColor: tenantVariables.primaryColor, color: tenantVariables.secondaryColor}} className="btn btn-play" id="submitButton"><strong>SUBMIT</strong></button>
                  </form>
                </div>
              </div>
            </center>
            <p id="thanks-for-playing-section" style={{color:tenantVariables.secondaryColor, display:"none", marginTop:"5%"}}><span className="thanksForPlayingLittleText">Thanks for</span><br/><span className="emphasizedText" style={{backgroundColor:tenantVariables.primaryColor, color:tenantVariables.secondaryColor}}>Playing</span></p>
            <div style={{width:"100%", textAlign: "center", padding:"10px"}}>
              <img width="100%" src={tenantVariables.sponsorLogo} alt="" style={{maxWidth:"380px", maxHeight:"280px"}}/>
            </div>
          </div>
        </div>
        )
    }

    render() {
      var tenantVariables = this.props.variables || {};
      if(!this.state.userEmail){
        return (
            <Redirect to="/login" />
        )
      }
      var renderMainScreen = this.renderHoldingScreen()
       // && !this.state.currentResponse.id
      if(this.state.gameActive && !this.state.questionAnswered){
        renderMainScreen = this.renderPlayingScreen()
      } else if(this.state.questionAnswered){
        renderMainScreen = this.thanksForPlayingScreen()
      }
      // else if(this.state.gameActive && !this.state.questionAnswered && this.state.currentResponse.id){
      //   renderMainScreen = this.playedWaitingScreen()
      // }
      return(
          <div className="flex-container-home" style={{backgroundImage: "url(" + tenantVariables.backgroundImage + ")"}}>
            {renderMainScreen}
          </div>
      )
    }
}

export default Main_App;



// WEBPACK FOOTER //
// ./src/components/main_screens/main_app.js